const e = {
  azure100: "#E5EFFF",
  azure200: "#B2CFFF",
  azure300: "#7EAEFF",
  azure400: "#4A8CFF",
  azure500: "#1769FF",
  azure600: "#0059FD",
  azure700: "#0051E4",
  azure800: "#0048CB",
  azure900: "#003FB2",
  black: "#000000",
  blue100: "#E5F1F7",
  blue200: "#B8D4E8",
  blue300: "#8CB4D7",
  blue400: "#618FC6",
  blue500: "#4169AA",
  blue600: "#3F629E",
  blue700: "#3C5C93",
  blue800: "#3A5587",
  blue900: "#374F7C",
  bronze100: "#F9F1E3",
  bronze200: "#EFD098",
  bronze300: "#EDB346",
  bronze400: "#D5900A",
  bronze500: "#8B5D00",
  bronze600: "#805706",
  bronze700: "#76510C",
  bronze800: "#6C4B11",
  bronze900: "#634616",
  green100: "#E4F4EE",
  green200: "#99E3BC",
  green300: "#41DF72",
  green400: "#0EB528",
  green500: "#006700",
  green600: "#0A6005",
  green700: "#13590A",
  green800: "#1A520F",
  green900: "#204B13",
  grey100: "#FAFAFA",
  grey200: "#F6F6F6",
  grey300: "#EDEDED",
  grey400: "#D3D3D3",
  grey500: "#BABABA",
  grey600: "#A0A0A0",
  grey700: "#878787",
  grey800: "#6E6E6E",
  grey900: "#545454",
  grey1000: "#212121",
  pink100: "#FEF3F9",
  pink200: "#FAB2DA",
  pink300: "#F96EBB",
  pink400: "#FB289C",
  pink500: "#DE007B",
  pink600: "#D10073",
  pink700: "#C3006C",
  pink800: "#B60064",
  pink900: "#A8005D",
  purple100: "#FBF4FB",
  purple200: "#E6B7E5",
  purple300: "#D178D0",
  purple400: "#BA3CB8",
  purple500: "#7D277B",
  purple600: "#752474",
  purple700: "#6E226C",
  purple800: "#661F65",
  purple900: "#5E1D5D",
  red100: "#FFEFEF",
  red200: "#FDB0B0",
  red300: "#F97375",
  red400: "#F3393D",
  red500: "#D91218",
  red600: "#C71617",
  red700: "#B61A19",
  red800: "#A51F1B",
  red900: "#95231D",
  white: "#FFFFFF"
}, n = {
  littlewoods: {
    enhancedText: e.white,
    onBlack: e.white,
    purple100: e.purple100,
    purple200: e.purple200,
    purple300: e.purple300,
    purple400: e.purple400,
    purple500: e.purple500,
    purple600: e.purple600,
    purple700: e.purple700,
    purple800: e.purple800,
    purple900: e.purple900,
    purpleDark: e.purple900,
    purpleMid: e.purple500,
    purpleLight: e.purple100
  },
  very: {
    enhancedText: e.black,
    onBlack: e.pink500,
    pink100: e.pink100,
    pink200: e.pink200,
    pink300: e.pink300,
    pink400: e.pink400,
    pink500: e.pink500,
    pink600: e.pink600,
    pink700: e.pink700,
    pink800: e.pink800,
    pink900: e.pink900,
    pinkDark: e.pink900,
    pinkMid: e.pink500,
    pinkLight: e.pink100
  }
}, r = {
  blueDark: e.blue900,
  blueMid: e.blue500,
  blueLight: e.blue100,
  bronzeDark: e.bronze900,
  bronzeMid: e.bronze500,
  bronzeLight: e.bronze100,
  greenDark: e.green900,
  greenMid: e.green500,
  greenLight: e.green100,
  redDark: e.red900,
  redMid: e.red500,
  redLight: e.red100
}, p = {
  divider: e.grey400,
  errorDark: r.redDark,
  errorMid: r.redMid,
  errorLight: r.redLight,
  focus: e.azure500,
  informationDark: r.blueDark,
  informationMid: r.blueMid,
  informationLight: r.blueLight,
  page: e.white,
  panelDark: e.grey200,
  panelMid: e.grey100,
  panelLight: e.white,
  successDark: r.greenDark,
  successMid: r.greenMid,
  successLight: r.greenLight,
  tintBlack10: "rgba(0,0,0,0.1)",
  tintBlack20: "rgba(0,0,0,0.2)",
  tintBlack90: `${e.black}e5`,
  tintWhite20: "rgba(f,f,f,0.2)",
  tintWhite90: `${e.white}e5`,
  tintRed90: `${r.redMid}e5`,
  warningDark: r.bronzeDark,
  warningMid: r.bronzeMid,
  warningLight: r.bronzeLight
};
export {
  n as brand,
  p as functional,
  e as global,
  r as universal
};
